import styled, { css } from 'styled-components';
import { getTextStyle } from '../../content/texts/bou-text/text-style';
import { BouColor } from '../../global/bou-colors';

export const niceInputStyle = css`
  ${getTextStyle({ size: 'xxs' })}
  display: flex;
  width: 100%;
  box-shadow: none;
  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${BouColor.TOOL_BORDER_DARK_GRAY};
    font-weight: normal;
    display: block;
  }
  :-ms-input-placeholder {
    color: ${BouColor.TOOL_BORDER_DARK_GRAY};
    font-weight: normal;
    display: block;
  }
  border: 1px solid ${BouColor.TOOL_INPUT_BORDER_DARK_GRAY};
  background-color: ${BouColor.TOOL_BACKGROUND_WHITE};
  border-radius: 1px;
  padding-right: 0.7em;
  padding-left: 0.7em;
  color: ${BouColor.TOOL_TEXT_BLACK};
  transition:
    0.25s border-color ease-in-out,
    0.25s color ease-in-out;
  & + & {
    margin-left: 16px;
  }
  &:hover {
    border-color: #8f8f8f;
  }
  &:active {
    border-color: ${BouColor.TOOL_TEXT_BLACK};
  }
  &:disabled {
    border-color: ${BouColor.TOOL_DISABLED_GRAY};
    background-color: ${BouColor.TOOL_DISABLED_GRAY};
    color: ${BouColor.TOOL_TEXT_LIGHT_GRAY};
  }
  &:focus {
    outline: none;
    border-color: ${BouColor.TOOL_TEXT_BLACK};
  }
`.join('');

export const NiceTextInput = styled.input<{ invalid?: boolean }>`
  ${niceInputStyle};
  ${props => (props.invalid ? `color: ${BouColor.TOOL_TEXT_ERROR_RED};` : '')}
  ${props =>
    props.invalid
      ? `
  border-color: ${BouColor.TOOL_TEXT_ERROR_RED};
  &:focus {
    border-color: ${BouColor.TOOL_TEXT_BLACK};
    color: ${BouColor.TOOL_TEXT_BLACK};
  }
  `
      : ''}

  height: 2.8em;
  align-items: center;
`;
